










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FitWxPhonex } from '@/fit-ui';

@Component({
  components: {
    FitWxPhonex,
  },
})
export default class FitLayout extends Vue {
  isIphonex = false;
  onResize(val) {
    this.isIphonex = val;
  }
}
